import axios from 'axios';
export const HTTP_ARIN = axios.create({
  baseURL: process.env.VUE_APP_ARIN_BASE_URL,
  timeout: 1000 * 500,
});
